import React, { useState } from "react";
import {
  MobileCardsContainer,
  MobileActivityCard,
  MobileStatusPill,
} from "../PatientPortal.styles";
import { convertirDecimalAnios } from "../../../utils/dateUtils";

export default function PatientPortalActivityCards({ data }) {
  // Por defecto, solo la primera tarjeta (índice 0) está abierta
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (idx) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  };

  const isVigente = (item) => {
    return item?.Vigencia === "Vigente" || item?.vigencia === "Vigente";
  };

  const getUltimaActividad = (item) => {
    const fecha = item?.MaxDeFecha_APIM || item?.ultimaActividad;
    if (!fecha || String(fecha).trim() === "") return "--";
    return fecha;
  };

  const getResultado = (item) => {
    const res = item?.Cod_Diagnostico || item?.resultado;
    if (!res || String(res).trim() === "" || !item?.MaxDeFecha_APIM) return "--";
    return res;
  };

  const getFrecuencia = (item) => {
    const vig = item?.MinDeVigencia ?? item?.minDeVigencia;
    if (vig === undefined || vig === null || String(vig).trim() === "") return "--";
    return convertirDecimalAnios(vig);
  };

  return (
    <MobileCardsContainer>
      <h3 className="mobile-section-heading">Actividades de Salud</h3>

      {data && data.length > 0 ? (
        data.map((item, idx) => {
          const vigente = isVigente(item);
          const isOpen = openIndex === idx;

          return (
            <MobileActivityCard
              key={item.cons || item.consecutivo || `mob-card-${idx}`}
              $isOpen={isOpen}
            >
              {/* Cabecera del acordeón clickeable */}
              <div
                className="card-top-header"
                onClick={() => toggleAccordion(idx)}
                role="button"
                tabIndex={0}
                aria-expanded={isOpen}
              >
                <div className="activity-title">
                  {item.APIM || item.actividad || "Actividad"}
                </div>

                <div className="header-right-actions">
                  <MobileStatusPill $vigente={vigente}>
                    {vigente ? "Vigente" : "Pendiente"}
                  </MobileStatusPill>

                  {/* Flecha indicadora de acordeón */}
                  <div className="chevron-icon">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Contenido desplegable solo visible si está abierto */}
              {isOpen && (
                <div className="card-details">
                  <div className="detail-row">
                    <strong>Última:</strong>
                    <span>{getUltimaActividad(item)}</span>
                  </div>
                  <div className="detail-row">
                    <strong>Resultado:</strong>
                    <span>{getResultado(item)}</span>
                  </div>
                  <div className="detail-row">
                    <strong>Frecuencia:</strong>
                    <span>{getFrecuencia(item)}</span>
                  </div>
                </div>
              )}
            </MobileActivityCard>
          );
        })
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "20px",
            color: "#64748b",
            background: "#ffffff",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          No hay actividades de salud registradas.
        </div>
      )}
    </MobileCardsContainer>
  );
}
